<template>
  <div
    v-loading="loading"
    class="menuManager app-container"
    style="position:relative;"
  >
    <!-- <split-pane :min-percent="15" :default-percent="70" split="vertical"> -->
    <div
      class="history-arrow"
      @click="clickCollapse"
    >
      <svg-icon
        v-show="!collapse"
        icon-class="history-z"
      />
      <svg-icon
        v-show="collapse"
        icon-class="history-s"
      />
    </div>
    <div
      class="history-down paneL"
      :style="{padding:'0 '+paneLeft +'px 0 0'}"
    >
      <div
        class="box-list"
        style="height: calc(100vh - 121px);"
      >
        <app-search>
          <div slot="content">
            <el-row
              :gutter="10"
              type="flex"
              justify="start"
              align="middle"
            >
              <el-col :span="8">
                <el-form
                  :label-position="'right'"
                  :model="listQuery"
                  :label-width="$t('statistical.hisDownloadSearch.searchLabelWidth1') "
                >
                  <el-form-item :label="$t('statistical.hisDownloadSearch.missionName') + '：'">
                    <el-input
                      v-model="listQuery.taskName"
                      filterable
                      clearable
                      :placeholder="$t('statistical.hisDownloadSearch.missionName')"
                    />
                  </el-form-item>
                </el-form>
              </el-col>
              <el-col :span="8">
                <el-form
                  :label-position="'right'"
                  :model="listQuery"
                  :label-width="$t('statistical.hisDownloadSearch.searchLabelWidth') "
                >
                  <el-form-item :label="$t('statistical.hisDownloadSearch.downloadStatus') + '：'">
                    <el-select
                      v-model="listQuery.status"
                      filterable
                      clearable
                      :placeholder="$t('statistical.hisDownloadSearch.downloadStatus')"
                    >
                      <el-option
                        v-for="(item,index) in commontData.downLoadStatus"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
          </div>
          <app-search-button
            slot="bottom"
            :position="{x:35,y:12}"
            :is-collapse="false"
            @click-collapse="handleCollapse"
            @click-filter="handleFilter"
            @click-clear="handleClear"
          />
        </app-search>
        <!-- 授权按钮 -->
        <app-authorize-button
          :data="authouizeList"
          @click-add-task="addTaskVisible= true"
          @click-delete-task="_deleteTask"
          @click-look-book="lookbook"
          @click-setCommonTask="handleSetTask(1)"
          @click-setSelfTask="handleSetTask(2)"
          @click-filter="showfilter=true"
        >
          <checked-Filter
            slot="check-filter"
            :show.sync="showfilter"
            :list="tableList"
          />
        </app-authorize-button>
        <el-table
          ref="tableLeft"
          v-loading="listLoading"
          size="mini"
          :data="list"
          :max-height="tableHeight"
          :header-row-style="headerRowStyle"
          :row-style="rowStyle"
          :header-cell-style="headerCellStyle"
          border
          fit
          highlight-current-row
          @row-click="rowClick"
          @sort-change="sortChange"
        >
          <el-table-column
            :label="$t('table.id')"
            align="center"
            width="45"
          >
            <template slot-scope="scope">
              <span>{{ (scope.$index+1)+(listQuery.pageNum -1)*listQuery.pageSize }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item,index) in filterTableList"
            :key="index"
            :label="item.value"
            :prop="item.prop"
            :align="item.position"
            :min-width="item.width"
            :sortable="item.sortable"
          >
            <template slot-scope="scope">
              <p v-if="item.prop==='completedcount'" class="process-history" >
                <el-progress
                  
                  :text-outside="true"
                  :stroke-width="10"
                  :percentage="scope.row[item.prop]"
                />
                </p>
                <span v-else>{{ scope.row[item.prop] | switchText(item.prop) }}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div :class="[total>0?'visible':'hidden','pagination-container']">
          <el-pagination
            :current-page="listQuery.pageNum"
            :page-sizes="[10,20,30,50]"
            :page-size="listQuery.pageSize"
            :total="total"
            background
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>

    <div
      v-show="!collapse"
      class="history-down paneR"
      :style="{width:paneRight +'px'}"
    >
      <div
        class="box-list"
        style="height: calc(100vh - 121px);position:relative;"
      >
        <app-search
          :title="$t('statistical.hisDownloadSearch.searchTitle')"
          :show-title="true"
          :icons="'download-child'"
        >
          <div slot="content">
            <el-row
              :gutter="10"
              type="flex"
              justify="start"
              align="middle"
            >
              <el-col :span="24">
                <el-form
                  :label-position="'right'"
                  :model="rightListQuery"
                  :label-width="$t('public.licensePlatewidth1')"
                  style="margin:12px 0;"
                >
                  <el-form-item :label="$t('public.licensePlate') + '：'">
                    <el-input
                      v-model="rightListQuery.licensePlate"
                      filterable
                      clearable
                      :placeholder="$t('public.licensePlate')"
                    />
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
            <el-row
              style="margin-top:10px"
              :gutter="10"
              type="flex"
              justify="start"
              align="middle"
            >
              <el-col :span="6">
                <el-form
                  :label-position="'right'"
                  label-width="70px"
                >
                  <el-form-item
                    label="占位符"
                    style="visibility: hidden;"
                  >
                    <el-input />
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
          </div>
          <app-search-button
            slot="bottom"
            :is-collapse="false"
            @click-collapse="handleCollapse"
            @click-filter="handleSearch"
            @click-clear="handleSearchClear"
          >
            <el-button
              v-waves
              type="primary"
               @click="downLoadZip"
            >
              <span>
                <svg-icon icon-class="all-down" /> {{ $t('statistical.hisDownloadSearch.downloadPackage') }}</span>
            </el-button>
          </app-search-button>
        </app-search>
        <el-table
          ref="table"
          v-loading="listLoadingRight"
          size="mini"
          :data="rightTableListData"
          :max-height="tableHeight"
          :header-row-style="headerRowStyle"
          :row-style="rowStyle"
          :header-cell-style="headerCellStyle"
          border
          fit
          highlight-current-row
          @row-click="rightRowClick"
        >
          <el-table-column
            :label="$t('table.id')"
            align="center"
            width="40"
          >
            <template slot-scope="scope">
              <span>{{ (scope.$index+1)+(listQuery.pageNum -1)*listQuery.pageSize }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item,index) in rightTableList"
            :key="index"
            :label="item.value"
            :prop="item.prop"
            :align="item.position"
            :min-width="item.width"
          >
            <template slot-scope="scope">
              <!-- 如果需要特性化显示可使用v-if，v-else-if，v-else-->
              <div v-if="item.prop==='fileschedule'">
                <span
                  v-if="scope.row.status!=4 && scope.row.status!=5"
                  class="progress-text"
                >{{ scope.row[item.prop] }}%</span>
                <span v-else>/</span>
              </div>
              <div v-else-if="item.prop==='licensePlate'">
                <div :class="[scope.row.status === 3 && scope.row.httpurl ? 'cursor':'']">
                <vue-licenseplate
                  :licensepalte="scope.row[item.prop]"
                  :area="scope.row['areaName']"
                />
                </div>
              </div>
              <div
                v-else
                :title="item.prop==='errornote' ? scope.row[item.prop]:''"
              >
                {{ scope.row[item.prop] | switchChildrenText(item.prop) }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div :class="[tightTotal>0?'visible':'hidden','pagination-container']">
          <el-pagination
            small
            :current-page="rightListQuery.pageNum"
            :page-sizes="[10,20,30,50]"
            :page-size="rightListQuery.pageSize"
            :total="tightTotal"
            background
            layout="total, prev, pager, next, jumper"
            @size-change="handleRightSizeChange"
            @current-change="handleRightCurrentChange"
          />
        </div>
      </div>
    </div>
    <!-- </split-pane> -->
    <add-task-dialog
      :visibles.sync="addTaskVisible"
      @add-complete="listLoad"
    />
  </div>
</template>

<script>
// request
import {
  getTask,
  deleteTask,
  setTask,
  getTaskDetail
} from '@/api/vehicletravel/downloadData'
// 混入
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'
import { getPageButton } from '@/mixins/getButton'
// 组件
import AddTaskDialog from './components/addTaskDialog'
// 辅助函数
import { mapGetters } from 'vuex'

export default {
  name: 'downloaddata',
  components: { AddTaskDialog },
  filters: {
    switchText(val, type) {
      if (type === 'status') {
        let text = ''
        switch (val) {
          case 1:
            text = vm.$t('statistical.hisDownloadTabel.queue')
            break
          case 2:
            text = vm.$t('statistical.hisDownloadTabel.processing')
            break
          case 3:
            text = vm.$t('statistical.hisDownloadTabel.compressing')
            break
          case 4:
            text = vm.$t('statistical.hisDownloadTabel.completed')
            break
          case 5:
            text = vm.$t('statistical.hisDownloadTabel.abnormal')
            break
          case 6:
            text = vm.$t('statistical.hisDownloadTabel.noHistoricalData')
            break
        }
        return text
      } else if (type === 'filetype') {
        return val === 1 ? 'Excel' : 'INR'
      } else if (type === 'tasklevel') {
        return val === 1 ? vm.$t('statistical.hisDownloadTabel.commonTasks') : vm.$t('statistical.hisDownloadTabel.urgentTasks')
      } else {
        return val || '/'
      }
    },
    switchChildrenText(val, type) {
      if (type === 'status') {
        let text = ''
        switch (val) {
          case 1:
            text = vm.$t('statistical.hisDownloadTabel.start')
            break
          case 2:
            text = vm.$t('statistical.hisDownloadTabel.processing')
            break
          case 3:
            text = vm.$t('statistical.hisDownloadTabel.completed')
            break
          case 4:
            text = vm.$t('statistical.hisDownloadTabel.abnormal')
            break
          case 5:
            text = vm.$t('statistical.hisDownloadTabel.noHistoricalData')
            break
        }
        return text
      } else {
        return val || '/'
      }
    }
  },
  mixins: [pagingMixin, otherHeight, tableStyle, getPageButton],
  computed: {
    ...mapGetters(['commontData']),
    // 由于v-for和v-if无法共存，必要情况下应该替换成computed
    // v-for比v-if优先，如果每一次都需要遍历整个数组，将会影响速度，尤其是当之需要渲染很小一部分的时候
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    }

  },
  data() {
    return {
      showfilter: false,
      dialogTableVisible: true,
      listQuery: {
        taskname: '',
        filetype: '1',
        status: ''
      },
      rightListQuery: {
        licensePlate: ''
      },
      rightTableList: [
        {
          value: this.$t('public.licensePlate'),
          prop: 'licensePlate',
          position: 'center',
          sortable: 'custom',
          width: this.$t('statistical.hisDownloadTabelWidth.tabelWidth3')
        },
        {
          value: this.$t("statistical.hisDownloadSearch.downloadStatus"),
          prop: "status",
          position: "center",
          width: this.$t("statistical.hisDownloadTabelWidth.tabelWidth3")
        },
        {
          value: this.$t('statistical.hisDownloadTabel.downloadProgress'),
          prop: 'fileschedule',
          position: 'center',
          sortable: 'custom',
          width: this.$t('statistical.hisDownloadTabelWidth.tabelWidth3')
        },
      ],
      rightTableListData: [],
      carList: [],
      listLoading: false,
      listLoadingRight: false,
      tableHeight: 0,
      tableRightHeight: 0,
      total: 0,
      tightTotal:0,
      list: [],
      tableRow: {},
      isEdit: false,
      loading: false, // 页面加载
      treeData: [],
      defaultCheckedKeys: [],
      treeLight: true,
      choiceTreeNode: null,
      choiceTreeData: null,
      addUpdateVisible: false,
      tableList: [
        {
          value: this.$t('statistical.hisDownloadSearch.missionName'),
          prop: 'taskname',
          position: 'center',
          width: this.$t('statistical.hisDownloadTabelWidth.tabelWidth3'),
          sortable: 'custom',
          checked: true
        },
        {
          value: this.$t('statistical.hisDownloadTabel.taskType'),
          prop: 'tasklevel',
          position: 'center',
          width: this.$t('statistical.hisDownloadTabelWidth.tabelWidth1'),
          sortable: 'custom',
          checked: true
        },
        {
          value: this.$t('statistical.hisDownloadTabel.downloadedVehicles'),
          prop: 'totalcount',
          position: 'center',
          width: this.$t('statistical.hisDownloadTabelWidth.tabelWidth3'),
          sortable: 'custom',
          checked: true
        },
        {
          value: this.$t('statistical.hisDownloadSearch.downloadStatus'),
          prop: 'status',
          position: 'center',
          width: this.$t('statistical.hisDownloadTabelWidth.tabelWidth3'),
          sortable: 'custom',
          checked: true
        },
        {
          value: this.$t('statistical.hisDownloadTabel.downloadProgress'),
          prop: 'completedcount',
          position: 'center',
          width: this.$t('statistical.hisDownloadTabelWidth.tabelWidth3'),
          sortable: 'custom',
          checked: true
        },
        {
          value: this.$t('statistical.hisDownloadTabel.downloader'),
          prop: 'loginName',
          position: 'center',
          width: this.$t('statistical.hisDownloadTabelWidth.tabelWidth3'),
          sortable: 'custom',
          checked: false
        },
        {
          value: this.$t('statistical.hisDownloadSearch.downloadType'),
          prop: 'filetype',
          position: 'center',
          width: this.$t('statistical.hisDownloadTabelWidth.tabelWidth3'),
          sortable: 'custom',
          checked: false
        },

        {
          value: this.$t('statistical.hisDownloadTabel.startTime'),
          prop: 'starttime',
          position: 'center',
          width: this.$t('statistical.hisDownloadTabelWidth.tabelWidth3'),
          sortable: 'custom',
          checked: true
        },
        {
          value: this.$t('statistical.hisDownloadTabel.endTime'),
          prop: 'endtime',
          position: 'center',
          width: this.$t('statistical.hisDownloadTabelWidth.tabelWidth3'),
          sortable: 'custom',
          checked: true
        },


        {
          value: this.$t('statistical.hisDownloadTabel.taskCreationTime'),
          prop: 'createdon',
          position: 'center',
          width: this.$t('statistical.hisDownloadTabelWidth.tabelWidth3'),
          sortable: 'custom',
          checked: true
        }
        // { value: '下载耗时', prop: 'querytime', position: 'center', width: 100, checked: true }
      ],
      addTaskVisible: false,
      collapse: false,
      paneLeft: '320',
      paneRight: '310'
    }
  },
  mounted() {
  },
  methods: {
    // 设置开始行程，结束行程内容左对齐
    // cellStyle(row) {
    //   if (row.column.label === this.rightTableList[0].value) {
    //     return { 'cursor': 'pointer' }
    //   }
    // },
    cellStyle() {
        return {
          overflow:'auto !important'
        }
    },
    // 加载数据
    listLoad() {
      this.listLoading = true
      this.tableRow = {}
      getTask(this.listQuery).then(({ data }) => {
        if (data.code === 0) {
          this.list = data.data || []
          this.total = data.total
          this.list.forEach(item => {
            item.completedcount =
              item.completedcount / item.totalcount > 1
                ? 100
                : Math.round((item.completedcount / item.totalcount) * 100, 1)
            item.querytime = this.switchTime(item.querytime)
          })
        }
        this.listLoading = false
      }).catch(()=>{
         this.listLoading = false
      })
    },
    // 时间转换
    switchTime(value) {
      if (value) {
        if (parseFloat(value) > 0 && parseFloat(value) < 60) {
          return value + vm.$t('carMonitor.monitorinfo.carStatus.seconds')
        } else if (parseFloat(value) >= 60 && parseFloat(value) < 3600) {
          return Math.floor(value / 60) + vm.$t('carMonitor.monitorinfo.carStatus.seconds') + (value % 60) + vm.$t('carMonitor.monitorinfo.carStatus.seconds')
        } else if (parseFloat(value) >= 3600 && parseFloat(value) < 86400) {
          return (
            Math.floor(value / 3600) +
            vm.$t('carMonitor.monitorinfo.carStatus.hours') +
            Math.floor((value % 3600) / 60) +
            vm.$t('carMonitor.monitorinfo.carStatus.seconds') +
            ((value % 3600) % 60) +
            vm.$t('carMonitor.monitorinfo.carStatus.seconds')
          )
        } else if (parseFloat(value) >= 86400) {
          return (
            Math.floor(value / 86400) +
            vm.$t('carMonitor.monitorinfo.carStatus.days') +
            Math.floor((value % 86400) / 3600) +
            vm.$t('carMonitor.monitorinfo.carStatus.hours') +
            Math.floor(((value % 86400) % 3600) / 60) +
            vm.$t('carMonitor.monitorinfo.carStatus.seconds') +
            (((value % 86400) % 3600) % 60) +
            vm.$t('carMonitor.monitorinfo.carStatus.seconds')
          )
        } else {
          return '/'
        }
      } else {
        return '/'
      }
    },
    // 左侧列点击
    rowClick(row) {
      this.tableRow = row
      this.handleSearch()
    },
    // 删除任务
    _deleteTask() {
      if (!this.tableRow.id) {
        this.$alert(this.$t('public.deleteTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
        return
      }
      if (this.tableRow.status === 2) {
        this.$message.error({
          message: this.$t('statistical.hisTips.taskInfo'),
          duration: 2000
        })
        return
      }
      const postData = {
        id: this.tableRow.id
      }
      this.$confirm(this.$t('public.deleteItemTips'), this.$t('public.tips'), {
        confirmButtonText: this.$t('public.define'),
        cancelButtonText: this.$t('public.cancel'),
        type: 'warning'
      })
        .then(() => {
          deleteTask(postData).then(({ data }) => {
            if (data.code === 0) {
              this.$message.success({
                message: this.$t('public.deleteSuccess'),
                duration: 2000
              })
              this.listLoad()
              this.tableRow = {}
            }
          })
        })
        .catch(() => {})
    },
    // 设置任务
    handleSetTask(tasklevel) {
      if (!this.tableRow.id) {
        this.$alert(this.$t('public.operationTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
        return
      }
      const postData = {
        taskid: this.tableRow.id,
        tasklevel
      }
      if (this.tableRow.status === 1) {
        setTask(postData).then(({ data }) => {
          if (data.code === 0) {
            this.$message.success({
              duration: 2 * 1000,
              message: this.$t('public.setSuccess')
            })
            this.listLoad()
          }
        })
      } else {
        let text = ''
        switch (this.tableRow.status) {
          case 1:
            text = vm.$t('statistical.hisDownloadTabel.queue')
            break
          case 2:
            text = vm.$t('statistical.hisDownloadTabel.processing')
            break
          case 3:
            text = vm.$t('statistical.hisDownloadTabel.compressing')
            break
          case 4:
            text = vm.$t('statistical.hisDownloadTabel.completed')
            break
          case 5:
            text = vm.$t('statistical.hisDownloadTabel.abnormal')
            break
          case 6:
            text = vm.$t('statistical.hisDownloadTabel.noHistoricalData')
            break
        }
        this.$message.error({
          message: text+' ' + this.$t('statistical.hisTips.stateInfo'),
          duration: 2000
        })
      }
    },
    // 查看说明说
    lookbook() {
      window.open('file/upload/template/历史数据下载操作说明书.pdf')
    },
    // 下载
    rightRowClick(row, column) {
      if (column.label === this.$t('public.licensePlate') && row.status === 3 && row.httpurl) {
        window.location.href = row.httpurl
      }
    },
    // 下载任务
    downLoadZip() {
      if (!this.tableRow.id) {
        this.$message.error({
          message: this.$t('statistical.hisTips.isSelect'),
          duration: 2 * 1000
        })
        return
      }
      if (this.tableRow.status === 4 && this.tableRow.httpurl) {
        window.location.href = this.tableRow.httpurl
      } else {
        this.$message.error({
          message: this.$t('statistical.hisTips.noSuccess'),
          duration: 2 * 1000
        })
      }
    },
    // 右侧查询
    handleSearch() {
      if (!this.tableRow.id) {
        this.$message.error({
          message: this.$t('statistical.hisTips.isSelect'),
          duration: 2 * 1000
        })
        return
      }
      const postData = {
        taskId: this.tableRow.id,
        licensePlate: this.rightListQuery.licensePlate,
        orderField: this.rightListQuery.orderField,
        direction: this.rightListQuery.direction,
        pageNum: 1,
        pageSize: 10
      }
      this.listLoadingRight = true
      getTaskDetail(postData).then(({ data }) => {
        if (data.code === 0) {
          this.rightTableListData = data.data || []
          this.tightTotal = data.total
        }
        this.listLoadingRight = false
      }).catch(()=>{
        this.listLoadingRight = false
      })
    },
    handleSearchClear(){
      this.rightListQuery = {
        orderField: '',
        direction: '',
        taskId:'',
        licensePlate: '',
        pageNum: 1,
        pageSize: 10
      }
    },
    /**
     * 处理分页大小改变
     * @param {number} value - 分页大小
     */
    handleRightSizeChange(value) {
      this.rightListQuery.pageNum = 1
      this.rightListQuery.pageSize = value
      this.handleSearch()
    },
    /**
     * 处理页码改变
     * @param {number} value - 页码
     */
    handleRightCurrentChange(value) {
      this.rightListQuery.pageNum = value
      this.handleSearch()
    },
    sortChangeDetail(row) {
      const direction = row.order
      if (direction === null) {
        return
      }
      this.rightListQuery.orderField = row.prop
      this.rightListQuery.direction = direction.replace(/ending/, '')
      this.handleSearch()
    },
    // 点击收缩展开
    clickCollapse() {
      this.collapse = !this.collapse
      if (this.collapse) {
        this.paneLeft = '0'
        this.paneRight = '0'
      } else {
        this.paneLeft = '320'
        this.paneRight = '310'
      }
    }
  }
}
</script>

<style lang="scss">
$color: #409eff;
$dangerColor: #f56c6c;
%btn_before {
  width: 1em;
  height: 1em;
  vertical-align: middle;
  display: inline-block;
  background-position: center center;
  background-size: 1em;
}
.tree-span {
  font-size: 13px;
}
.menu_info_div {
  padding: 6px;
  font-size: 12px;
}
.scroll_list {
  height: calc(100vh - 197px);
}
.organization-name-search {
  position: relative;
  padding: 5px;
}

.or-name-btn {
  position: absolute;
  top: 5px;
  right: 5px;
}
.form-area .el-form-item__label {
  line-height: 38px;
}
.authorize-left-button {
  display: flex;
  padding-left: 5px;
  li {
    flex-wrap: wrap;

    cursor: pointer;
    padding: 5px 0;
    border-radius: 3px;
    p {
      font-size: 12px;
      border-right: 1px solid rgb(227, 233, 227);
      margin: 0;
      padding: 0 6px;
    }
    &:last-child {
      p {
        border-right: none;
      }
    }
    &:hover {
      background: #c6e2ff;
      color: #fff;
    }
  }
}
.history-arrow {
  position: absolute;
  top: 20px;
  right: 22px;
  z-index: 22;
  svg {
    cursor: pointer;
    font-size: 16px !important;
  }
}
.paneL {
  float: left;
  width: 100%;
  box-sizing: border-box;
  .search_content {
    padding-right: 35px !important;
  }
}
.paneR {
  position: absolute;
  top: 0;
  right: 0;
  margin: 10px;
  box-sizing: border-box;
}
.history-down {
  .el-table .cell,
  .el-table th div,
  .el-table .cell,
  .el-table th div,
  .el-table--border td:first-child .cell,
  .el-table--border th:first-child .cell {
    padding: 0 5px;
  }
}
.cursor{
  cursor: pointer;
  *{
    color:#409eff!important;
  }
  .licenseplate{
    border: 2px solid #409eff!important;
  }
}
.paneR .el-form{
  margin:0!important;
}
</style>

